import styled from 'styled-components';

export const GroupContainer =  styled.div`
border: 1px solid #e7e8ec;
border-radius: 8px;
`


export const GroupHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
  gap: 24px;
  padding: 12px;
`;

export const GroupHeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  justify-content: space-between;
`;

export const GroupHeaderRight = styled.div`
  display: flex;
  align-items: center;
`;
export const ChevronIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transform: ${(props) => (props.$isExpanded ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s ease;
`;

export const GroupContent = styled.div`
  display: flex;
  flex-direction: column;
`;

